export class SummaryReportRequest {
    fromDate: string;
    toDate: string;

    /**
     * 
     * @param fromDate 
     * @param toDate 
     */
    constructor(fromDate: string, toDate: string) {
        this.fromDate = fromDate;
        this.toDate = toDate;
    }
}